<template lang="pug">
div
  card-financeiro(
    cardTitle="Cálculo do VTN"
  )
    template(slot="body")
      validation-observer(ref='observer')
        router-view
  app-buttons-cadastro(
    :isPrimeiroPasso="isPrimeiroPasso",
    :isUltimoPasso="isUltimoPasso",
    :showButtonSalvar="isUltimoPasso",
    :showButtonProximo="!isUltimoPasso"
    @proximo="proximo",
    @salvar="salvarCadastro",
    @voltar="voltar",
    @cancelar="cancelar",
    @finalizar="finalizarCadastro"
  )
</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import CardFinanceiro from '../components/CardFinanceiro'

export default {
  mixins: [
    AppNotificacao
  ],

  beforeRouteLeave (to, from, next) {
    if (!this.isCancelar) {
      this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          this.$store.commit('vtn/CLEAR_VTN')
          next()
        },
        () => {
        }, 'Sim', 'Não')
    } else {
      this.$store.commit('vtn/CLEAR_VTN')
      next()
    }
  },

  data () {
    return {
      isCancelar: false,
      passoAtual: 0,
      passos: [
        {
          descricao: 'Dados VTN',
          name: 'vtn/dadosVtn'
        },
        {
          descricao: 'Custas',
          name: 'vtn/custas'
        },
        {
          descricao: 'Forma de pagamento',
          name: 'vtn/pagamento'
        },
        {
          descricao: 'Resumo',
          name: 'vtn/resumo'
        }
      ]
    }
  },

  components: {
    AppButtonsCadastro,
    CardFinanceiro
  },

  async created () {
    await this.$store.dispatch('vtn/setConstants')
    await this.$store.dispatch('vtn/getVtnProcesso', this.$route.params.numeroProcesso)

    switch (this.$route.name) {
      case 'vtn/dadosVtn':
        this.passoAtual = 0
        break
      case 'vtn/custas':
        this.passoAtual = 1
        break
      case 'vtn/pagamento':
        this.passoAtual = 2
        break
      case 'vtn/resumo':
        this.passoAtual = 3
        break
      default:
        this.passoAtual = 0
    }
  },

  computed: {
    isPrimeiroPasso () {
      return this.passoAtual === 0
    },

    isUltimoPasso () {
      return this.passoAtual === this.passos.length - 1
    }
  },

  methods: {
    async proximo () {
      const validate = await this.validarCampos()

      if (!validate) {
        this.showNotificacao('warning', 'Atenção!', 'Verifique os campos destacados antes de salvar.')
        return
      }

      const result = await this.$store.dispatch('vtn/saveOrUpdate', this.$route.params.numeroProcesso)

      if (result && this.passoAtual !== this.passoAtual.length - 1) {
        this.showNotificacao('success', 'Sucesso!', 'VTN salva com sucesso.')
        this.navigate(this.passoAtual + 1)
      }
    },

    async voltar () {
      await this.$store.dispatch('vtn/getVtnProcesso', this.$route.params.numeroProcesso)

      const index = this.passoAtual - 1

      this.navigate(index)
    },

    async salvarCadastro () {
      const validate = await this.validarCampos()

      if (!validate) {
        this.showNotificacao('warning', 'Atenção!', 'Verifique os campos destacados antes de salvar.')
        return
      }

      const result = await this.$store.dispatch('vtn/saveOrUpdate', this.$route.params.numeroProcesso)

      if (result) {
        this.showNotificacao('success', 'Sucesso!', 'VTN salva com sucesso.')
      }
    },

    cancelar () {
      this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          this.$store.commit('vtn/CLEAR_VTN')
          this.isCancelar = true
          this.$router.push({
            name: 'cof/visualizarProcessoFisico',
            params: {
              numeroProcesso: this.$route.params.numeroProcesso
            }
          })
        },
        () => {
        }, 'Sim', 'Não')
    },

    finalizarCadastro () {
      this.confirmBox('Você tem certeza que deseja finalizar a VTN? Os dados não poderão mais ser alterados.', this.$messages.TITULO_WARNING,
        () => {
          this.$store.dispatch('vtn/finalizar').then(() => {
            this.isCancelar = true
            this.$router.push({
              name: 'cof/visualizarProcessoFisico',
              params: {
                numeroProcesso: this.$route.params.numeroProcesso
              }
            })
            this.showNotificacao('success', 'Sucesso!', 'VTN finalizada com sucesso.')
          })
        },
        () => {
        }, 'Sim', 'Não')
    },

    navigate (indexTab) {
      this.$router.push({
        name: this.passos[indexTab].name
      })

      this.passoAtual = indexTab
    },

    validarCampos () {
      return this.$refs.observer.validate()
    }
  }
}
</script>

<style lang="scss" scoped>

.pad {
  padding: 0px 20px 20px 20px;
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/vtn/Home.vue